import { ID } from '@griply/types';

// An empty array next to a filled scalar is never written on purpose (`build-task-link-writes` derives
// the scalar from the array), so it means the array was left behind — read the scalar instead.
export const linkIdsOf = (ids?: ID[] | null, legacyId?: ID | null): ID[] => {
  // `delete-goals` reads documents without a converter, so this can be handed anything.
  if (Array.isArray(ids)) {
    const valid = ids.filter((id): id is ID => typeof id === 'string' && !!id);
    if (valid.length) {
      // Every count and every write downstream assumes one entry per link.
      return valid.length === 1 ? valid : Array.from(new Set(valid));
    }
  }

  return typeof legacyId === 'string' && !!legacyId ? [legacyId] : [];
};
